export const DEFAULT_DATAGRAIL_LAYER_ID = 'categories-layer'

/**
 * Shows the DataGrail consent banner for the user
 */
export const showDataGrailConsentBanner = () => {
  try {
    if (typeof window !== 'undefined' && window?.DG_BANNER_API) {
      window.DG_BANNER_API.showLayer(DEFAULT_DATAGRAIL_LAYER_ID)
    }
  } catch (error) {
    console.error('Failed to show DataGrail consent banner', { error })
  }
}

export const showDataGrailConsentBannerOnLoad = () => {
  if (typeof window === 'undefined') return

  // If document is already loaded, execute immediately
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    if (window?.DG_BANNER_API) {
      showDataGrailConsentBanner()
    } else {
      console.warn('DataGrail banner API not available')
    }
    return
  }

  // Otherwise, add the DOMContentLoaded event listener
  document.addEventListener('DOMContentLoaded', () => {
    if (window?.DG_BANNER_API) {
      showDataGrailConsentBanner()
    } else {
      console.warn('DataGrail banner API not available after DOMContentLoaded')
    }
  })
}

// Type definition for DataGrail Banner API based on https://docs.datagrail.io
declare global {
  interface Window {
    DG_BANNER_API?: {
      /**
       * Shows a specific layer/consent banner by ID
       * @param layerId The ID of the layer to show
       */
      showLayer: (layerId: string) => void
    }
  }
}
